import { render } from "./StatuSettings.vue?vue&type=template&id=0d44766c&ts=true"
import script from "./StatuSettings.vue?vue&type=script&lang=ts"
export * from "./StatuSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__